<template>
  <div class="HeaderImgBox">
    <img
      v-if="imgUrl"
      :src="imgUrl"
    />
    <img
      v-else
      src="@/assets/images/user/defaultHeaderImg.png"
    />
  </div>
</template>

<script>
export default {
  name: 'header-img-box',
  props: {
    imgUrl: String,
  },
};
</script>

<style lang="scss">
.HeaderImgBox {
  width: 40px;
  height: 40px;
}
</style>

